import api from '@/api/api';
import { TId } from '@/features/common';
import { parseAPIData, serialiseAPIData } from '@/utils/parsers';

import { EAutomationType, IAutomation } from '../types';

const BASE_URL = import.meta.env.VITE_API_URL + '/api/v3';

export async function fetchAutomations(params: {
  workspaceId: TId;
  jobOpeningId: TId;
}): Promise<IAutomation[]> {
  const response = await api.get(
    `/workspaces/${params.workspaceId}/openings/${params.jobOpeningId}/automations`,
    { baseURL: BASE_URL }
  );

  return parseAPIData<IAutomation[]>(response.data);
}

export async function createAutomation(params: {
  workspaceId: TId;
  jobOpeningId: TId;
  stageId: TId;
  details: {
    type: EAutomationType;
    enabled: boolean;
    destinationStageId: TId | null;
    templateId: TId | null;
    systemTemplateId: TId | null;
    value: number | null;
  };
}): Promise<IAutomation> {
  const response = await api.post(
    `/workspaces/${params.workspaceId}/openings/${params.jobOpeningId}/stages/${params.stageId}/automations`,
    serialiseAPIData(params.details),
    { baseURL: BASE_URL }
  );

  return parseAPIData<IAutomation>(response.data);
}

export async function updateAutomation(params: {
  workspaceId: TId;
  jobOpeningId: TId;
  stageId: TId;
  automationId: TId;
  details: {
    enabled: boolean;
    destinationStageId: TId | null;
    templateId: TId | null;
    systemTemplateId: TId | null;
    value: number | null;
  };
}): Promise<IAutomation> {
  const response = await api.patch(
    `/workspaces/${params.workspaceId}/openings/${params.jobOpeningId}/stages/${params.stageId}/automations/${params.automationId}`,
    serialiseAPIData(params.details),
    { baseURL: BASE_URL }
  );

  return parseAPIData<IAutomation>(response.data);
}

export async function deleteAutomation(params: {
  workspaceId: TId;
  jobOpeningId: TId;
  stageId: TId;
  automationId: TId;
}): Promise<void> {
  await api.delete(
    `/workspaces/${params.workspaceId}/openings/${params.jobOpeningId}/stages/${params.stageId}/automations/${params.automationId}`,
    { baseURL: BASE_URL }
  );
}

export async function runAutomation(params: {
  workspaceId: TId;
  jobOpeningId: TId;
  stageId: TId;
  automationId: TId;
  candidateIds: TId[];
}): Promise<void> {
  await api.post(
    `/workspaces/${params.workspaceId}/openings/${params.jobOpeningId}/stages/${params.stageId}/automations/${params.automationId}`,
    serialiseAPIData(params.candidateIds),
    { baseURL: BASE_URL }
  );
}
